import BaseService from './core/base.service';
import { SERVICE_NAMES } from './core/service-names';

class NotificationsService extends BaseService {
  async find(params) {
    const response = await this.repository.find(params);
    return this.handleResponse(response);
  }

  async get(itemUnique) {
    const response = await this.repository.get(itemUnique);
    return this.handleResponse(response);
  }

  async getUnreadCount() {
    const response = await this.repository.getUnreadCount();
    return this.handleResponse(response);
  }

  async read(itemUnique) {
    const response = await this.repository.read(itemUnique);
    return this.handleResponse(response);
  }

  async respond(itemUnique, request) {
    const response = await this.repository.respond(itemUnique, request);
    return this.handleResponse(response);
  }
}

export default new NotificationsService(SERVICE_NAMES.NOTIFICATIONS);
